import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

/**
 * Stronger Minimal Text Navigation
 * Clean typography on left side, more visual presence
 * No heavy backgrounds, but clearer hierarchy
 */
export default function MinimalTextNavigation({ currentSection = 'home', onNavigate }) {
  const navigate = useNavigate();

  const menuItems = [
    { id: 'home', label: 'HOME' },
    { id: 'work', label: 'OUR WORK' },
    { id: 'systems', label: 'SYSTEMS' },
    { id: 'portfolio', label: 'PORTFOLIO' },
    { id: 'about', label: 'ABOUT' },
    { id: 'build', label: 'BUILD WITH US' }
  ];

  const teamPortal = { id: 'portal', label: 'TEAM PORTAL' };

  return (
    <div className="fixed left-0 top-0 h-screen flex flex-col justify-between py-16 pl-12 pr-8 z-50">
      {/* Logo Top - Larger */}
      <div className="mb-20">
        <button onClick={() => navigate('/')} className="block">
          <img
            src="/logos/eternity-wordmark.png"
            alt="Eternity"
            className="h-10 w-auto object-contain opacity-95 hover:opacity-100 transition-opacity duration-300"
            style={{ filter: 'brightness(0) invert(1)' }}
          />
        </button>
      </div>

      {/* Main Menu - Stronger Typography */}
      <nav className="flex-1 flex flex-col gap-8">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onNavigate && onNavigate(item.id)}
            className="group relative text-left"
          >
            <span
              className={`text-base font-semibold tracking-wider transition-all duration-300 ${
                currentSection === item.id
                  ? 'text-[#FF6B35]'
                  : 'text-white/50 hover:text-white/90'
              }`}
              style={{ 
                fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
                letterSpacing: '0.08em',
                fontSize: '15px'
              }}
            >
              {item.label}
            </span>
            
            {/* Active Indicator - Stronger */}
            {currentSection === item.id && (
              <motion.div
                layoutId="activeIndicator"
                className="absolute left-[-32px] top-1/2 -translate-y-1/2 w-4 h-[3px] bg-gradient-to-r from-[#FF6B35] to-[#FF8F66] rounded-full"
                transition={{ type: "spring", stiffness: 380, damping: 30 }}
              />
            )}
          </button>
        ))}
      </nav>

      {/* Team Portal - Separated */}
      <div className="mt-auto pt-10 border-t border-white/[0.08]">
        <button
          onClick={() => navigate('/login')}
          className="group relative text-left"
        >
          <span
            className="text-base font-semibold tracking-wider text-white/40 hover:text-[#FF6B35] transition-colors duration-300"
            style={{ 
              fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif',
              letterSpacing: '0.08em',
              fontSize: '15px'
            }}
          >
            {teamPortal.label}
          </span>
        </button>
      </div>
    </div>
  );
}
